import React, { useState } from 'react';
import { FaTrash, FaEdit, FaUserPlus } from 'react-icons/fa';
import ReactPaginate from 'react-paginate';
import '../Styles/CardTorneo.css';
import { AgregarCardBoton } from '../../AddCard/Components/AddComponent';
import usuario2 from '../../../assets/usuario2.png'
const CardUsuarios = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 6;

  const usuarios = [
    {
      id: 1,
      nombre: 'Juan Pérez',
      email: 'juanperez@example.com',
      rol: 'Administrador',
    },
    {
      id: 2,
      nombre: 'María Gómez',
      email: 'mariagomez@example.com',
      rol: 'Usuario',
    },
    {
      id: 3,
      nombre: 'Pedro Rodríguez',
      email: 'pedrorodriguez@example.com',
      rol: 'Moderador',
    },
  ];

  const filteredUsuarios = usuarios.filter(usuario =>
    usuario.nombre.toLowerCase().includes(searchTerm.toLowerCase()) ||
    usuario.rol.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  const displayUsuarios = filteredUsuarios
    .slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage)
    .map(usuario => (
      <div key={usuario.id} className="torneo-card">
        <h3>{usuario.nombre}</h3>
        <p>Email: {usuario.email}</p>
        <p>Rol: {usuario.rol}</p>
        <div className="button-container">
          <button><FaEdit /> Actualizar</button>
          <button><FaTrash /> Eliminar</button>
          <button><FaUserPlus /> Agregar Usuario</button>
        </div>
      </div>
    ));

  return (
    <div>
      <input
        type="text"
        placeholder="Buscar usuarios..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        className="search-input"
      />

      <div className="card-container">
        <div className="background-div">
            <AgregarCardBoton image={usuario2}/> 
        </div>
        {displayUsuarios}
      </div>
      <ReactPaginate
        pageCount={Math.ceil(filteredUsuarios.length / itemsPerPage)}
        onPageChange={handlePageClick}
        containerClassName="pagination"
        activeClassName="active"
        previousLabel={"< Anterior"}
        nextLabel={"Siguiente >"}
      />
    </div>
  );
};

export { CardUsuarios };
